import * as React from 'react';
import { Placeholder } from './components/Placeholder';
import { Thumbnail } from './components/Thumbnail';

export const AvatarThumbnail = ({ initials, showUpload, ...thumbnailProps }: avatar.IAvatarThumbnailProps) => {
    const thumbnailRef = React.createRef<HTMLDivElement>();

    return (
        <>
            <Thumbnail
                ref={thumbnailRef}
                placeholder={(props) => <Placeholder {...props} initials={initials} species="Human" />}
                shape="Circular"
                showUpload={showUpload}
                showLoading
                role="img"
                {...thumbnailProps}
            />
        </>
    );
};
